import { PurchaseOrderUpdatePage } from "@/features/purchase-order/pages/PurchaseOrderUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-order/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_order.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseOrderUpdatePage,
});
